module.exports = __webpack_public_path__ + "img/TypeReport.9005effd.svg";